"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeparatedPropsMode = exports.FieldPropsOccurrence = exports.AllowedFieldPropsTypes = exports.FieldPropsEnum = void 0;
var FieldPropsEnum;
(function (FieldPropsEnum) {
    FieldPropsEnum["key"] = "key";
    FieldPropsEnum["id"] = "id";
    FieldPropsEnum["path"] = "path";
    FieldPropsEnum["name"] = "name";
    FieldPropsEnum["fields"] = "fields";
    FieldPropsEnum["ref"] = "ref";
    FieldPropsEnum["type"] = "type";
    FieldPropsEnum["value"] = "value";
    FieldPropsEnum["initial"] = "initial";
    FieldPropsEnum["default"] = "default";
    FieldPropsEnum["checked"] = "checked";
    FieldPropsEnum["label"] = "label";
    FieldPropsEnum["placeholder"] = "placeholder";
    FieldPropsEnum["error"] = "error";
    FieldPropsEnum["validatedWith"] = "validatedWith";
    FieldPropsEnum["validators"] = "validators";
    FieldPropsEnum["rules"] = "rules";
    FieldPropsEnum["related"] = "related";
    FieldPropsEnum["options"] = "options";
    FieldPropsEnum["extra"] = "extra";
    FieldPropsEnum["bindings"] = "bindings";
    FieldPropsEnum["hooks"] = "hooks";
    FieldPropsEnum["handlers"] = "handlers";
    FieldPropsEnum["input"] = "input";
    FieldPropsEnum["output"] = "output";
    FieldPropsEnum["interceptors"] = "interceptors";
    FieldPropsEnum["observers"] = "observers";
    // computed
    FieldPropsEnum["disabled"] = "disabled";
    FieldPropsEnum["deleted"] = "deleted";
    FieldPropsEnum["blurred"] = "blurred";
    FieldPropsEnum["validating"] = "validating";
    FieldPropsEnum["submitting"] = "submitting";
    FieldPropsEnum["clearing"] = "clearing";
    FieldPropsEnum["resetting"] = "resetting";
    FieldPropsEnum["changed"] = "changed";
    FieldPropsEnum["touched"] = "touched";
    FieldPropsEnum["focused"] = "focused";
    FieldPropsEnum["isEmpty"] = "isEmpty";
    FieldPropsEnum["isDefault"] = "isDefault";
    FieldPropsEnum["isPristine"] = "isPristine";
    FieldPropsEnum["isDirty"] = "isDirty";
    FieldPropsEnum["isValid"] = "isValid";
    FieldPropsEnum["hasError"] = "hasError";
    // handlers
    FieldPropsEnum["onInit"] = "onInit";
    FieldPropsEnum["onSync"] = "onSync";
    FieldPropsEnum["onChange"] = "onChange";
    FieldPropsEnum["onBlur"] = "onBlur";
    FieldPropsEnum["onFocus"] = "onFocus";
    FieldPropsEnum["onToggle"] = "onToggle";
    FieldPropsEnum["onDrop"] = "onDrop";
    FieldPropsEnum["onSubmit"] = "onSubmit";
    FieldPropsEnum["onReset"] = "onReset";
    FieldPropsEnum["onClear"] = "onClear";
    FieldPropsEnum["onAdd"] = "onAdd";
    FieldPropsEnum["onDel"] = "onDel";
    FieldPropsEnum["autoFocus"] = "autoFocus";
    FieldPropsEnum["inputMode"] = "inputMode";
    FieldPropsEnum["onKeyDown"] = "onKeyDown";
    FieldPropsEnum["onKeyUp"] = "onKeyUp";
})(FieldPropsEnum = exports.FieldPropsEnum || (exports.FieldPropsEnum = {}));
var AllowedFieldPropsTypes;
(function (AllowedFieldPropsTypes) {
    AllowedFieldPropsTypes["computed"] = "computed";
    AllowedFieldPropsTypes["observable"] = "observable";
    AllowedFieldPropsTypes["editable"] = "editable";
    AllowedFieldPropsTypes["all"] = "all";
})(AllowedFieldPropsTypes = exports.AllowedFieldPropsTypes || (exports.AllowedFieldPropsTypes = {}));
var FieldPropsOccurrence;
(function (FieldPropsOccurrence) {
    FieldPropsOccurrence["some"] = "some";
    FieldPropsOccurrence["every"] = "every";
})(FieldPropsOccurrence = exports.FieldPropsOccurrence || (exports.FieldPropsOccurrence = {}));
var SeparatedPropsMode;
(function (SeparatedPropsMode) {
    SeparatedPropsMode["values"] = "values";
    SeparatedPropsMode["labels"] = "labels";
    SeparatedPropsMode["placeholders"] = "placeholders";
    SeparatedPropsMode["defaults"] = "defaults";
    SeparatedPropsMode["initials"] = "initials";
    SeparatedPropsMode["disabled"] = "disabled";
    SeparatedPropsMode["deleted"] = "deleted";
    SeparatedPropsMode["types"] = "types";
    SeparatedPropsMode["related"] = "related";
    SeparatedPropsMode["rules"] = "rules";
    SeparatedPropsMode["options"] = "options";
    SeparatedPropsMode["bindings"] = "bindings";
    SeparatedPropsMode["extra"] = "extra";
    SeparatedPropsMode["hooks"] = "hooks";
    SeparatedPropsMode["handlers"] = "handlers";
    SeparatedPropsMode["validatedWith"] = "validatedWith";
    SeparatedPropsMode["validators"] = "validators";
    SeparatedPropsMode["observers"] = "observers";
    SeparatedPropsMode["interceptors"] = "interceptors";
    SeparatedPropsMode["input"] = "input";
    SeparatedPropsMode["output"] = "output";
    SeparatedPropsMode["autoFocus"] = "autoFocus";
    SeparatedPropsMode["inputMode"] = "inputMode";
    SeparatedPropsMode["refs"] = "refs";
})(SeparatedPropsMode = exports.SeparatedPropsMode || (exports.SeparatedPropsMode = {}));
